import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface AdminNavItem {
  label: string;
  icon: string;
  path: string;
}

interface AdminNavViewItem extends AdminNavItem {
  active: boolean;
}

@Component({
  selector: 'admin-nav',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './nav.component.html',
  styleUrl: './nav.component.scss',
})
export class AdminNavComponent {
  @Input() items: AdminNavItem[] = [];
  @Input() activePath = '';

  get viewItems(): AdminNavViewItem[] {
    return this.items.map((item) => ({
      ...item,
      active: item.path === this.activePath,
    }));
  }
}
